import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OfferCTCBreakup {
    id: number;
    ctc_id: number;
    ctc_name: string;
    offer_id: number;
    amount: string;
}

interface OfferDetails {
    id: number;
    uuid: string;
    company_id: number;
    company_name: string;
    branch_id: number;
    branch_name: string;
    candidate_id: number;
    candidate_name: string;
    vertical_code_id: number;
    vertical_code: string;
    user_id: number;
    user_name: string;
    status: string;
    email: string;
    pan: string,
    aadhaar: string,
    mobile: string,
    address: string,
    designation: string;
    department_id: number;
    department_name: string;
    expected_joining_date: string;
    ctc: string;
    deduction: string;
    first_approver: number;
    first_approval_name: string;
    second_approver: string;
    second_approval_name: string;
    third_approver: string;
    third_approval_name: string;
    approval_id: number;
    created_at: string;
    updated_at: string;
    DeletedAt: string | null;
    remark: string;
    offer_ctc_breakup: OfferCTCBreakup[];
    gross_salary: string;
}

interface OfferState {
    offerDetails: OfferDetails | null;
}

const initialState: OfferState = {
    offerDetails: null,
};

const offerSlice = createSlice({
    name: 'offer',
    initialState,
    reducers: {
        setOfferDetails: (state, action: PayloadAction<OfferDetails>) => {
            state.offerDetails = action.payload;
        },
        clearOfferDetails: (state) => {
            state.offerDetails = null;
        },
    },
});

export const { setOfferDetails, clearOfferDetails } = offerSlice.actions;
export default offerSlice.reducer;
